<script setup lang="ts">
// 74
</script>

<template>
  <IadWrapper
    class="bg-secondary-40 text-white rounded-t-3xl lg:rounded-t-none"
    inner-classes="py-xl"
  >
    <IadTitle
      :text="$t(`homepage.agent.title`)"
      variant="large"
      tag="h2"
      class="pb-xl"
    />
    <div class="lg:grid lg:grid-cols-4 gap-l pb-xl">
      <img
        src="~/assets/images/homepage/agent-1.jpg"
        loading="lazy"
        :alt="$t(`homepage.agent.image_alt_1`)"
        class="rounded-xl ratio-square w-[300px] lg:w-auto mx-auto lg:mx-none object-cover"
      >
      <img
        src="~/assets/images/homepage/agent-2.jpg"
        loading="lazy"
        :alt="$t(`homepage.agent.image_alt_2`)"
        class="rounded-xl hidden lg:inline ratio-square object-cover"
      >
      <img
        src="~/assets/images/homepage/agent-3.jpg"
        loading="lazy"
        :alt="$t(`homepage.agent.image_alt_3`)"
        class="rounded-xl hidden lg:inline ratio-square object-cover"
      >
      <img
        src="~/assets/images/homepage/agent-4.jpg"
        loading="lazy"
        :alt="$t(`homepage.agent.image_alt_4`)"
        class="rounded-xl hidden lg:inline ratio-square object-cover"
      >
    </div>
    <IadTitle
      :text="$t(`homepage.agent.hook`)"
      class="pb-s"
      variant="small-semibold"
      tag="p"
    />
    <FindAgentSector
      class="lg:w-10/12 mx-auto"
      :placeholder="$t(`homepage.agent.placeholder`)"
    />
  </IadWrapper>
</template>
